import { css } from "styled-components";
import { rem, math } from "polished";

const ADAFont = (fontSize: string) => {
  return css`
    font-size: ${rem(fontSize)};
    letter-spacing: ${rem(math(`${fontSize} * 0.12`))};
    word-spacing: ${rem(math(`${fontSize} * 0.16`))};
    line-height: ${rem(math(`${fontSize} * 1.5`))};
  `;
};

const FontWithLineHeight = (fontSize: string) => {
  return css`
    font-size: ${rem(fontSize)};
    line-height: ${rem(math(`${fontSize} * 1.5`))};
  `;
};

export { ADAFont, FontWithLineHeight };
